module.exports = __webpack_public_path__ + "media/images/modules/publisher/tabs/live-1a3ba21b3c4f91966ef0f6630c94e2a9.png";